import React, { useState, useEffect, useContext } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    Select as WALLET_SELECT,
    AEPSToOtherWalletTransfer
} from 'Components/Api/WalletApi';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import {
    Container,
    Grid,
    Paper,
    MenuItem,
    CircularProgress
} from '@material-ui/core';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import InputLabel from 'Components/Inputes/InputLabel';
import { AEPS_WalletID } from 'Components/Helper/Messages';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { BalanceContext } from 'Components/BalanceContext';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import FormHeader from 'Components/FormHeader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import PayIcon from 'Components/SvgButtons/PayIcon';

const CustomContainer = HOCLoader(Container);

const WalletTransfer = () => {
    const classes = commonStyle();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [severity, setSeverity] = useState('success');
    const [InWords, setInWords] = useState('');

    const [wallets, setWallets] = useState([]);
    useEffect(() => {
        selectWallets();
    }, []);

    const selectWallets = async () => {
        var request = {
            ID: 0
        };
        var json = JSON.stringify(request);
        const response = await WALLET_SELECT(json);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        data = data.filter((d) => {
            return d.WalletID !== AEPS_WalletID;
        });

        setWallets(data);
    };

    const OnAmountChange = (value, setFieldValue) => {
        if (value === undefined || value < 0) return;
        setInWords(NumberToWord(value));
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }
        var requestObj = JSON.stringify(values);

        setIsError(false);
        setLoading(true);

        var response = await AEPSToOtherWalletTransfer(requestObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);
        DashboardBalanceUpdate();

        resetForm(FormObj);
        reset();
    };
    const [FormObj, setFormObj] = useState({
        WalletID: 0,
        Amount: '',
        InWords: '',
        Remark: ''
    });
    const reset = () => {
        setInWords('');
        setFormObj({
            WalletID: 0,
            Amount: '',
            InWords: '',
            Remark: ''
        });
    };

    const FormValidationSchema = Yup.object({
        WalletID: Yup.number()
            .moreThan(0, PLEASE_SELECT_VALID + ' wallet')
            .required(PLEASE_SELECT_VALID + ' wallet'),
        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount'),
        Remark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark')
    });

    const updateWalletID = async (value, setFieldValue) => {};
    const WalletList = wallets.map(({ WalletID, Name }) => (
        <MenuItem key={WalletID} value={WalletID}>
            {Name}
        </MenuItem>
    ));

    const WalletTransferForm = ({ setFieldValue }) => {
        return (
            <Form>
                <FormHeader
                    title=" Transfer"
                    shouldDisplayButton={false}
                    buttonName=""
                    link=""
                />

                <Grid item xs={12}>
                    <Paper className={classes.PaperStyle}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <MaterialSelect
                                    label="Wallet"
                                    name="WalletID"
                                    title="Select Wallet"
                                    onCustomCallback={(name, value) => {
                                        updateWalletID(value, setFieldValue);
                                    }}
                                >
                                    <MenuItem key="0" value={0}>
                                        Select Wallet
                                    </MenuItem>
                                    {WalletList}
                                </MaterialSelect>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialCurrency
                                    name="Amount"
                                    label="Amount"
                                    placeholder="Amount"
                                    autoComplete="new-password"
                                    max={999999}
                                    onCustomCallback={(value) => {
                                        OnAmountChange(value, setFieldValue);
                                    }}
                                />
                                <InputLabel color="green" value={InWords} />
                            </Grid>

                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                <MaterialTextField
                                    label="Remark"
                                    name="Remark"
                                    type="text"
                                    length={150}
                                    title="Remark"
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <PrimaryButton
                                    type="submit"
                                    title="Transfer"
                                    endIcon={<PayIcon />}
                                    className={classes.CustomPrimaryButtonStyle}
                                    disabled={loading}
                                ></PrimaryButton>
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                    />
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} lg={2}>
                                <SecondaryButton
                                    variant="contained"
                                    color="secondary"
                                    type="reset"
                                    endIcon={<ResetIcon />}
                                    title="Reset"
                                    onClick={() => {
                                        reset();
                                    }}
                                    className={classes.CustomDangerButtonStyle}
                                ></SecondaryButton>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Form>
        );
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {WalletTransferForm}
            </Formik>
        </CustomContainer>
    );
};

export default WalletTransfer;
